import { Component } from '@angular/core';

@Component({
  templateUrl: './schedule-page.component.html',
})
export class SchedulePageComponent {}
